import React from 'react';
import Pro01 from "../../images/services/ac/technical-development.webp"
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Agile(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container classNanme="h-100">
                <Row classNanme="h-100">
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
                        <div className="example" data-text="ur Work ">
                            <h2>Our Work In Numbers</h2>
                        </div>
                        <p>Think TekRevol when you think technical development. From simple chatbots to massive traffic
                            optimization programs for material management companies, TekRevol has created and empowered
                            the digital infrastructures of diverse startups and enterprise-grade organizations across
                            the globe. Our people, processes, products, and projects are a source of stretching our
                            global digital footprint and speak volumes about why we do what we do.</p>

                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="agile_title my-auto offset-xl-1">
                        <div className="content_pointer">
                            <div className="pointers_item">
                                <div className="title_count">55+<span>Applications Delivered</span></div>
                            </div>
                            <div className="pointers_item">
                                <div className="title_count">34+<span>Businesses Transformed</span></div>
                            </div>
                            <div className="pointers_item">
                                <div className="title_count">11+<span>Industries Served</span></div>
                            </div>
                        </div>
                        <LazyLoadImage
                            src={Pro01}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Agile;